import React from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  useFormHandler,
} from "../../../../../components";

const FromToDateModal = ({ isOpen, onClose, value, onChange, onSave,...res }) => {
  const handleSave = () => {
    if (onSave) {
      onSave(value);
      // send selected dates back to
      onClose();
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="By Dates"
      //   width="max-w-2xl"
    >
      {/* <div className="px-4"> */}
      <div className="my-4 ">
        <FormFieldSet
          type="datepickerRange"
          title="From and To Date"
          placeholder="Select From and To Date"
          value={value}
          onChange={onChange}
          {...res}
        />
      </div>

      <div className="flex justify-end gap-3 mt-6">
        <Button title={"Save"} onClick={() => handleSave()} />
      </div>
    </Modal>
  );
};

export default FromToDateModal;
